
import appError from '#shared/util/appError.js';
import json from '#shared/util/json.js';
import logger from '#shared/util/logger.js';
import readArguments from '#shared/util/readArguments.js';

import asyncCall from './asyncCall.js';
import onWindowClose from './onWindowClose.js';

/**
 * Offer on cart/window close
 * @param {object} options
 * @param {string} options.brand avast/avg
 * @param {string[]} options.customIDs
 * @param {string} options.productSKU e.g. PRD-00
 * @param {string|number} options.subscriptionLength e.g. 12
 * @param {string} options.campaign e.g. CAMPAIGN
 * @param {string} options.campaignMarker e.g. CAMPAIGN-MARKER
 */
const set = function({ brand = 'avast', customIDs = [], productSKU = '', subscriptionLength = '', campaign = '', campaignMarker = '' } = {}) {
	if (customIDs.includes('CLOSEOFFERNO')) {
		return;
	}
	if (typeof brand === 'string' && typeof productSKU === 'string' && productSKU !== '') {
		// eslint-disable-next-line
		onWindowClose(function closeWindowOffer() {
			const opmCall = `${brand}.opm.set_event`;
			return new Promise((resolve) => {
				asyncCall(opmCall, ([, error]) => {
					if (error) {
						logger.warn({
							code: 'CLIENT',
							origin: opmCall,
							detail: json.parse(error) || {}
						});
					} else {
						resolve();
					}
				}, {
					version: 1,
					id: 'CLOSE_OFFER_EVENT',
					ipm_values: [{
						p_copp: 'CLOSE_OFFER_CHECKOUT',
						p_coai: productSKU,
						p_cosl: subscriptionLength, // months validity
						p_codis: campaign,
						p_cocm: campaignMarker
					}]
				});
			});
		});
	} else {
		throw appError('Invalid method arguments to closeWindowOffer', {
			code: 'APP_FRONTEND_UTIL',
			origin: 'closeWindowOffer',
			detail: readArguments(arguments) // @todo update detail structure
		});
	}
};

/**
 * Call unsetCloseOffer method to disable close offer
 */
const unset = function() {
	// eslint-disable-next-line
	onWindowClose(function closeWindowOffer() {});
};

export default {
	set,
	unset
};
